import { File } from "lucide-react";
import { useNavigate } from "react-router-dom";

function ReportPresentationButton({ presentationId }) {
  const navigate = useNavigate();

  const handleReport = () => {
    navigate(`/report-presentation/${presentationId}`);
  };
  return (
    <div>
      <button
        onClick={handleReport}
        className="px-4 py-2 bg-lightPurple hover:bg-purpleColor text-sm text-white rounded-lg shadow hover:scale-105 transition flex gap-2 items-center"
      >
        <File className="w-4 h-4" />
        <span>Report</span>
      </button>
    </div>
  );
}

export default ReportPresentationButton;
